import { render, staticRenderFns } from "./PreviewLink.vue?vue&type=template&id=7ac12c5e&scoped=true&"
import script from "./PreviewLink.vue?vue&type=script&lang=js&"
export * from "./PreviewLink.vue?vue&type=script&lang=js&"
import style0 from "./PreviewLink.vue?vue&type=style&index=0&id=7ac12c5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac12c5e",
  null
  
)

export default component.exports